var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "projectRef", staticClass: "project-form-package" },
    [
      _vm.tempFormConf.showItem == "start"
        ? [
            _vm.getBackgroundStyle && _vm.getFormTheme.enable
              ? _c("div", {
                  staticClass: "define-theme-form",
                  style: _vm.getBackgroundStyle,
                  on: {
                    click: function ($event) {
                      return _vm.getShowModule("project")
                    },
                  },
                })
              : _c(
                  "div",
                  {
                    staticClass: "project-form-main",
                    style: _vm.getBackgroundStyle,
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "flex-column project-form-start" },
                      [
                        _c("div", { staticStyle: { width: "100%" } }, [
                          _vm.getFormTheme.showTitle
                            ? _c("div", {
                                staticClass: "title-box",
                                domProps: {
                                  innerHTML: _vm._s(_vm.formConf.title),
                                },
                              })
                            : _vm._e(),
                        ]),
                        _c("div", { staticClass: "posi-relative" }, [
                          _c("img", {
                            staticClass: "form-start-icon",
                            attrs: {
                              src: require("@/assets/images/form-bg2.png"),
                              alt: "",
                            },
                          }),
                          _c("img", {
                            staticClass: "describe-html-icon",
                            attrs: {
                              src: require("@/assets/images/form-bg3.png"),
                              alt: "",
                            },
                          }),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.getFormTheme.showDescribe,
                                  expression: "getFormTheme.showDescribe",
                                },
                              ],
                              staticClass: "describe-html-content",
                            },
                            [_vm._v(_vm._s(_vm.formConf.description))]
                          ),
                        ]),
                        _c(
                          "el-button",
                          {
                            staticClass: "start-btn",
                            attrs: { type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.getShowModule("project")
                              },
                            },
                          },
                          [_vm._v("开始答题")]
                        ),
                      ],
                      1
                    ),
                  ]
                ),
          ]
        : _vm._e(),
      _vm.tempFormConf.showItem == "project"
        ? _c(
            "div",
            {
              staticClass: "project-form-main flex-column",
              style: _vm.getAnswerBackgroundStyle,
            },
            [
              _vm.showSvgList
                ? _c("div", { staticClass: "svg-list" }, [
                    _c(
                      "span",
                      { staticClass: "svg-list-item svg-list-item-yellow" },
                      [_c("svg-icon", { attrs: { name: "yellow" } })],
                      1
                    ),
                    _c(
                      "span",
                      { staticClass: "svg-list-item svg-list-item-green" },
                      [_c("svg-icon", { attrs: { name: "green" } })],
                      1
                    ),
                  ])
                : _vm._e(),
              _vm.showUserLogo
                ? _c("div", { staticStyle: { "margin-bottom": "8%" } }, [
                    _c("img", {
                      staticClass: "define-logo-img",
                      attrs: { src: _vm.showUserLogo },
                    }),
                  ])
                : _vm._e(),
              _c(
                "div",
                {
                  staticClass: "project-form-item",
                  class: _vm.getFormMainClass,
                },
                [
                  _c(
                    "div",
                    { staticClass: "project-form-item-content" },
                    [
                      _vm.getFormTheme.logoImg
                        ? _c(
                            "div",
                            {
                              style: {
                                textAlign: _vm.getFormTheme.logoPosition,
                              },
                            },
                            [
                              _c("img", {
                                staticClass: "logo-img",
                                attrs: { src: _vm.getFormTheme.logoImg },
                              }),
                            ]
                          )
                        : _vm._e(),
                      _vm.getFormTheme.headImgUrl
                        ? _c("el-image", {
                            staticStyle: { width: "100%" },
                            attrs: { src: _vm.getFormTheme.headImgUrl },
                          })
                        : _vm._e(),
                      !_vm.pageSettingData.pageShowMore
                        ? [
                            _c("div", { staticClass: "progress-bar-wrap" }, [
                              _c("div", { staticClass: "progress-bar-inner" }, [
                                _c("div", { staticClass: "progress-bar" }, [
                                  _c("div", {
                                    staticClass: "progress-bar-bg",
                                    style: {
                                      width: _vm.bgwidth,
                                      background:
                                        _vm.getFormTheme.progressBarColor,
                                    },
                                  }),
                                ]),
                                _c("div", { staticClass: "progress-num" }, [
                                  _vm._v(
                                    _vm._s(_vm.showCurrPage) +
                                      " / " +
                                      _vm._s(
                                        _vm.formConf.fields[0].totalPageNum
                                      )
                                  ),
                                ]),
                              ]),
                            ]),
                          ]
                        : _vm._e(),
                      !_vm.getAnswerBackgroundStyle
                        ? _c("div", { staticClass: "posi-relative el-svg" }, [
                            _c(
                              "span",
                              {
                                class: [
                                  "svg-star",
                                  {
                                    "svg-star-morebt":
                                      _vm.pageSettingData.pageShowMore,
                                  },
                                ],
                              },
                              [_c("svg-icon", { attrs: { name: "star" } })],
                              1
                            ),
                            _c(
                              "span",
                              { staticClass: "svg-circle" },
                              [_c("svg-icon", { attrs: { name: "circle" } })],
                              1
                            ),
                          ])
                        : _vm._e(),
                      _vm.startParser
                        ? _c("parser", {
                            key: _vm.parserKey,
                            ref: "pageContent",
                            staticClass: "p15",
                            attrs: {
                              "form-conf": _vm.tempFormConf,
                              "logic-trigger-item-list":
                                _vm.logicTriggerItemList,
                              "page-form-model": _vm.pageFormModel,
                              pageShowMore: _vm.pageSettingData.pageShowMore,
                            },
                            on: {
                              "update:logicTriggerItemList": function ($event) {
                                _vm.logicTriggerItemList = $event
                              },
                              "update:logic-trigger-item-list": function (
                                $event
                              ) {
                                _vm.logicTriggerItemList = $event
                              },
                              "update:pageFormModel": function ($event) {
                                _vm.pageFormModel = $event
                              },
                              "update:page-form-model": function ($event) {
                                _vm.pageFormModel = $event
                              },
                              next: _vm.nextPage,
                              prev: _vm.prevPage,
                              submit: _vm.submit,
                            },
                          })
                        : _vm._e(),
                    ],
                    2
                  ),
                  _vm.tempFormConf && _vm.tempFormConf.formBtns
                    ? _c(
                        "div",
                        {
                          staticClass: "flex-center",
                          staticStyle: { width: "100%" },
                        },
                        [
                          _vm.showSubmitBtn
                            ? [
                                _c(
                                  "el-button",
                                  {
                                    class: [
                                      {
                                        "btn-fixed":
                                          !_vm.pageSettingData.pageShowMore,
                                      },
                                      "submit-btn-form-item submit-btn-form-item-define",
                                    ],
                                    style: _vm.getSubmitBtnStyle,
                                    attrs: {
                                      type: "primary",
                                      loading: _vm.btnLoading,
                                    },
                                    on: { click: _vm.submitFormBtn },
                                  },
                                  [
                                    !_vm.getSubmitBtnStyle ||
                                    _vm.tempFormConf.theme
                                      .answerPageSubButtonType === 1
                                      ? _c("span", [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.tempFormConf.theme &&
                                                  _vm.tempFormConf.theme
                                                    .submitBtnText
                                                  ? _vm.tempFormConf.theme
                                                      .submitBtnText
                                                  : "提交"
                                              ) +
                                              " "
                                          ),
                                        ])
                                      : _vm._e(),
                                  ]
                                ),
                              ]
                            : _vm._e(),
                          _vm.tempFormConf.resetBtn
                            ? _c(
                                "el-button",
                                {
                                  class: [
                                    {
                                      "btn-fixed":
                                        !_vm.pageSettingData.pageShowMore,
                                    },
                                    "submit-btn-form-item",
                                  ],
                                  on: { click: _vm.resetForm },
                                },
                                [_vm._v(" 重置 ")]
                              )
                            : _vm._e(),
                        ],
                        2
                      )
                    : _vm._e(),
                ]
              ),
            ]
          )
        : _vm._e(),
      _vm.tempFormConf.showItem == "end"
        ? [
            _vm.getBackgroundStyle && _vm.getFormTheme.enable
              ? _c("div", {
                  staticClass: "define-theme-form",
                  style: _vm.getBackgroundStyle,
                })
              : _c(
                  "div",
                  {
                    staticClass: "project-form-main flex-column",
                    style: _vm.getBackgroundStyle,
                  },
                  [
                    _c("div", { staticClass: "svg-list" }, [
                      _c(
                        "span",
                        { staticClass: "svg-list-item svg-list-item-yellow" },
                        [_c("svg-icon", { attrs: { name: "yellow" } })],
                        1
                      ),
                      _c(
                        "span",
                        { staticClass: "svg-list-item svg-list-item-green" },
                        [_c("svg-icon", { attrs: { name: "green" } })],
                        1
                      ),
                    ]),
                    _c(
                      "div",
                      {
                        staticClass:
                          "project-form-item project-form-end project-form-item-default",
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "flex-column",
                            staticStyle: { "align-items": "center" },
                          },
                          [
                            _c("img", {
                              staticClass: "form-end-img",
                              attrs: {
                                src: require("@/assets/images/form-end.png"),
                                alt: "",
                              },
                            }),
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.pageSettingData
                                    .submitShowCustomPageContent || "提交成功"
                                )
                              ),
                            ]),
                          ]
                        ),
                        _c(
                          "span",
                          { staticClass: "text-center support-text" },
                          [
                            _vm._v(
                              _vm._s(_vm.getDevSupport) + " - 提供技术支持"
                            ),
                          ]
                        ),
                      ]
                    ),
                  ]
                ),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }